import { Header } from 'components/Layout/Header/Header';
import { useMarketplace } from 'hooks/useMarketplace';
import React from 'react';
import { useSelector } from 'react-redux';
import { getOnlineBookingProgress } from 'reducers/onlineBooking/OnlineBookingSelectors';

interface OnlineBookingHeaderProps {
    onBack?: () => void;
}

// Every step renders its own header, so the bar is a fresh DOM node on each navigation
// and CSS has nothing to transition from. Replaying the previous value fixes that.
let previousProgress = 0;

export const OnlineBookingHeader: React.FC<OnlineBookingHeaderProps> = ({ onBack }) => {
    const { logo } = useMarketplace();
    const progress = useSelector(getOnlineBookingProgress);

    const [displayedProgress, setDisplayedProgress] = React.useState(previousProgress);

    React.useEffect(() => {
        previousProgress = progress;

        // Two frames so the browser paints the starting width before it changes.
        let innerFrame: number;
        const outerFrame = requestAnimationFrame(() => {
            innerFrame = requestAnimationFrame(() => setDisplayedProgress(progress));
        });

        return () => {
            cancelAnimationFrame(outerFrame);
            cancelAnimationFrame(innerFrame);
        };
    }, [progress]);

    return <Header progress={displayedProgress} logo={logo} onBack={onBack} />;
};
